/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState,useEffect } from "react";

// react-router-dom components
import { useLocation, NavLink, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard React examples
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavCard from "examples/Sidenav/SidenavCard";

// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
import { useMenu } from "newContext/MenuContext";

// Soft UI Dashboard React context
import { useSoftUIController, setMiniSidenav } from "context";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const [controller, dispatch] = useSoftUIController();
   const { isMenuOpen } = useMenu();
    const { setIsMenuOpen } = useMenu();
  const { miniSidenav, transparentSidenav } = controller;
  const location = useLocation();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];
  const[userAccess,setUserAccess] = useState('');
  const[userEmail,setUserEmail] = useState('');
  const[userName,setUserName] = useState('');
  const[variant,setVariant] = useState('');
  const [rightsData,setRightsData]= useState({})
  const [isAdmin,setIsAdmin]= useState(false)
  const closeSidenav = () => setMiniSidenav(dispatch, true);
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem('userRoles')) { 
      let roles= JSON.parse(localStorage.getItem("userRoles"));
      setRightsData(roles[0]);
      let user_data= JSON.parse(localStorage.getItem("userdetails"))
      console.log("data user>> ", user_data)
      setIsAdmin(user_data.isadmin===0 ?false:true);
      }else{
        // navigate('/');
      }
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  useEffect(()=>{
    console.log("working>> ", isMenuOpen)
  },[isMenuOpen])

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  const renderRoutes = routes.map(({ type, name, icon, title, noCollapse, key, route, href, permissionKey }) => {
    if (rightsData&& permissionKey && rightsData[permissionKey] === 0) {
      return null; // Skip rendering if permissionKey exists and rightsData[permissionKey] is 0
    }
    if(permissionKey==="for_admin" && !isAdmin){
      return null;
    }
    let returnValue;

    // if (key === "bp-form" && variant === "vendor") {
    //   return null; 
    // }
  
    // if (key === "vendor-form" && variant === "bp") {
    //   return null;
    // }

    if (type === "collapse" && name!='Sign In') {
      returnValue = href ? (
        <Link
          href={href}
          key={key}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <SidenavCollapse
            color={color}
            name={name}
            icon={icon}
            active={key === collapseName}
            noCollapse={noCollapse}
          />
        </Link>
      ) : (
        <NavLink to={route} key={key}>
          <SidenavCollapse
            color={color}
            key={key}
            name={name}
            icon={icon}
            active={key === collapseName}
            noCollapse={noCollapse}
          />
        </NavLink>
      );
    } else if (type === "title") {
      returnValue = (
        <SoftTypography
          key={key}
          display="block"
          variant="caption"
          fontWeight="bold"
          textTransform="uppercase"
          opacity={0.6}
          pl={3}
          mt={2}
          mb={1}
          ml={1}
        >
          {title}
        </SoftTypography>
      );
    } else if (type === "divider") {
      returnValue = <Divider key={key} />;
    }

    return returnValue;
  });

  return (
    <SidenavRoot {...rest} variant="permanent" ownerState={{ transparentSidenav, miniSidenav }} className={isMenuOpen?"sliderMobNav":""}>
      <SoftBox pt={3} pb={1} px={4} textAlign="center">
        <SoftBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <SoftTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }} onClick={()=>setIsMenuOpen(false)}>close</Icon>
          </SoftTypography>
        </SoftBox>
        <SoftBox
  component={NavLink}
  to="/"
  display="flex"
  alignItems="center"
  flexDirection="column"
  textAlign="center" // make sure text is centered
>
  {brand && (
    <SoftBox
      component="img"
      src={brand}
      alt="Anmol Logo"
      width="4rem"
      mb={1}
    />
  )}
  <SoftBox
    width="100%" // make it full width to allow proper centering
    display="flex"
    justifyContent="center"
    sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
  >
    <SoftTypography component="h6" variant="button" fontWeight="medium">
      {brandName}
    </SoftTypography>
  </SoftBox>
</SoftBox>


      </SoftBox>
      <Divider />
      <List>{renderRoutes}</List>
      {/* <SoftBox pt={2} my={2} mx={2} mt="auto">
        <SidenavCard />
        <SoftBox mt={2}>
          <SoftButton
            component="a"
            href="https://creative-tim.com/product/soft-ui-dashboard-pro-react"
            target="_blank"
            rel="noreferrer"
            variant="gradient"
            color={color}
            fullWidth
          >
            upgrade to pro
          </SoftButton>
        </SoftBox>
      </SoftBox> */}
    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
